export default __webpack_public_path__ + "static/media/TestLeft-Logo.8e088bc1.svg";